module.exports = __webpack_public_path__ + "img/i-chat-white.c77d3758.svg";